export default __webpack_public_path__ + "static/WebSite_3DShowcaseMu3_VideoQHD-d699da981a51366e514a09bec15dafec.mp4";